export const notificationTypesRoute = {
  BUILDING_ADDED: ({ buildingId }: { buildingId: string }) => {
    if (!buildingId) return undefined;
    const link = `/buildings/${buildingId}`;
    return link;
  },
  JOB_CREATED: ({ JobTechnicianId }: { JobTechnicianId: string }) => {
    if (!JobTechnicianId) return undefined;
    const link = `/create-jobs/details/technician/${JobTechnicianId}`;
    return link;
  },
  PROPOSAL_CREATED: ({ proposalId }: { proposalId: string }) => {
    if (!proposalId) return undefined;
    const link = `/proposal/${proposalId}`;
    return link;
  },

  PROPOSAL_RECEIVED: ({ jobAndProposalId }: { jobAndProposalId: string }) => {
    if (!jobAndProposalId) return undefined;
    const link = `/proposals/${jobAndProposalId}`;
    return link;
  },
  PROPOSAL_STATUS: ({ proposalId }: { proposalId: string }) => {
    if (!proposalId) return undefined;
    const link = `/proposal/${proposalId}`;
    return link;
  },
  CONTRACT_CREATE: ({ contractId }: { contractId: string }) => {
    if (!contractId) return undefined;
    const link = `/contract/${contractId}`;
    return link;
  },

  CONTRACT_ACCEPT: ({ contractId }: { contractId: string }) => {
    if (!contractId) return undefined;
    const link = `/contract-client/${contractId}`;
    return link;
  },
  CONTRACT_REJECT: ({ contractId }: { contractId: string }) => {
    if (!contractId) return undefined;
    const link = `/contract-client/${contractId}`;
    return link;
  },
  CONTRACT_CANCEL: ({ contractId }: { contractId: string }) => {
    if (!contractId) return undefined;
    const link = `/contract/${contractId}`;
    return link;
  },

  JOB_CREATED_FOR_TECHNICIAN: (data: any) => {
    console.log(data);
  },

  PRINTER_ASSOCIATE_WITH_CLIENT: ({
    associatePrinter,
  }: {
    associatePrinter: string;
  }) => {
    if (!associatePrinter) return undefined;
    const link = `/printer?printer=${associatePrinter}`;
    return link;
  },

  PRINTER_JOB_CREATED: (data: any) => {
    console.log(data);
  },
  PRINTER_JOB_STATUS: (data: any) => {
    console.log(data);
  },

  PDF_UPLOAD: ({
    jobAndProposal,
    jobId,
  }: {
    jobAndProposal: string;
    jobId: string;
  }) => {
    if (!jobAndProposal && !jobId) return undefined;
    const link = `/jobs/details/${jobAndProposal}/jobs/${jobId}`;
    return link;
  },
  PDF_SEND_TO_REVIEW: ({
    jobAndProposal,
    jobId,
    jobProcessId,
  }: {
    jobAndProposal?: string;
    jobId?: string;
    jobProcessId?: string;
    reviewId?: string;
  }) => {
    let link;
    if (jobAndProposal && jobId) {
      link = `/jobs/details/${jobAndProposal}/jobs/${jobId}`;
    }
    if (jobProcessId) {
      link = `/reviews/${jobProcessId}`;
    }
    return link;
  },

  PDF_REVIEW_JOB_PROCESS: ({
    jobAndProposal,
    jobId,
  }: {
    jobAndProposal: string;
    jobId: string;
  }) => {
    if (!jobAndProposal && !jobId) return undefined;
    const link = `/jobs/details/${jobAndProposal}/jobs/${jobId}`;
    return link;
  },
  PDF_SEND_TO_CLIENT: ({ jobAndProposalId }: { jobAndProposalId: string }) => {
    let link;
    if (jobAndProposalId) {
      link = `/my-jobs/${jobAndProposalId}`;
    }

    return link;
  },

  //Drafts Job notification
  DRAFTS_JOB_CREATED: ({ draftsJobId }: { draftsJobId: string }) => {
    console.log(draftsJobId);
  },
  DRAFTS_JOB_ACCEPTED: ({ draftsJobId }: { draftsJobId: string }) => {
    console.log(draftsJobId);
  },
  DRAFTS_JOB_REJECTED: ({ draftsJobId }: { draftsJobId: string }) => {
    console.log(draftsJobId);
  },
  DRAFTS_UPLOADED: ({
    draftsJobId,
    draftsJobProcessId,
  }: {
    draftsJobId: string;
    draftsJobProcessId: string;
  }) => {
    console.log(draftsJobId, draftsJobProcessId);
  },
  DRAFTS_ASSIGNED_FIREMAN: ({
    draftsJobId,
    draftsJobProcessId,
  }: {
    draftsJobId: string;
    draftsJobProcessId: string;
  }) => {
    console.log(draftsJobId, draftsJobProcessId);
  },
  DRAFTS_SEND_FIREMAN_REVIEW: ({
    draftsJobId,
    draftsJobProcessId,
  }: {
    draftsJobId: string;
    draftsJobProcessId: string;
  }) => {
    console.log(draftsJobId, draftsJobProcessId);
  },
  DRAFTS_REVIEW_BY_FIREMAN: ({
    draftsJobId,
    draftsJobProcessId,
  }: {
    draftsJobId: string;
    draftsJobProcessId: string;
  }) => {
    console.log(draftsJobId, draftsJobProcessId);
  },
  DRAFTS_SENT_TO_CLIENT: ({
    draftsJobId,
    draftsJobProcessId,
  }: {
    draftsJobId: string;
    draftsJobProcessId: string;
  }) => {
    console.log(draftsJobId, draftsJobProcessId);
  },
} as const;
